import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, DatePipe } from '@angular/common';
import { RequiredLabelDirective } from './directives/required-label.directive';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DynamicFieldDirective } from './dynamicform/components/dynamic-field/dynamic-field.directive';
import { DynamicFormComponent } from './dynamicform/dynamic-form/dynamic-form.component';
import { FormButtonComponent } from './dynamicform/components/form-button/form-button.component';
import { FormInputComponent } from './dynamicform/components/form-input/form-input.component';
import { FormSelectComponent } from './dynamicform/components/form-select/form-select.component';
import { AutoCompleteComponent } from './autosearch/auto-search.component';
// VirtualScrollerModule was removed; using CDK ScrollingModule instead
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TileComponent } from './tile/tile.component';
import { KeysValue } from './pipes/keyvalue-pipe.pipe';
import { SelectOptionPipe } from './pipes/select-option.pipe';
import { RecentlySearchedComponent } from './recently-searched/recently-searched.component';
import {  InputtypeDirective } from './utilities/inputtype.directive';
import { BottomPopOverComponent } from './bottom-pop-over/bottom-pop-over.component';
import { TitleComponent } from './title/title.component';
import { AutocompletesearchComponent } from './component/autocomplete/auto-complete.component';
import { ToastMessageComponent } from './toast-message/toast-message.component';
import { ItemListTableComponent } from './item-list-table/item-list-table.component';
import { ItemDetailsComponent } from './item-details/item-details.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NummaxLengthDirective } from './directives/num-maxlength.directive';
import { SearchBoxComponent } from './search-box/search-box.component';
import { PopupComponent } from './popup/popup.component';
import { TableSearchComponent } from './table-search/table-search.component';
import { ServersideutoCompleteComponent } from './component/autocomplete-serverside/autocomplete-serverside.component';
import { FormtoggleComponent } from './dynamicform/components/form-toggle/form-toggle.component';
import { FormdateComponent } from './dynamicform/components/form-date/form-date.component';
import { FormTextareaComponent } from './dynamicform/components/form-textarea/form-textarea.component';
import { MatFormFieldModule } from '@angular/material/form-field';




import { FormNumberComponent } from './dynamicform/components/form-number/form-number.component';
import { ScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ListPackagesComponent } from './list-packages/list-packages.component';
import { AllLocationsComponent } from './all-locations/all-locations.component';
import { IsEmpty } from './pipes/is-empty.pipe';
import { Sort } from './pipes/sort.pipe';
import { ResetbuttonComponent } from './dynamicform/components/form-reset-button/form-reset-button.component';
import { FormInputAutocompleteComponent } from './dynamicform/components/form-input-autocomplete/form-input-autocomplete.component';

import { FormAutocompleteComponent } from './dynamicform/components/form-autocomplete/form-autocomplete.component';
import { HighlightPipe } from './pipes/highlight-char.pipe';
import { GetIconName } from './pipes/get-Icon-name.pipe';
import { ViewmoreDirective } from './directives/view-more.directive';
import { NoItemsComponent } from './no-items/no-items.component';
import { TrimLower } from './pipes/trim-lower-str.pipe';
import { PackageListComponentComponent } from './package-list-component/package-list-component.component';
import { FilterPipe } from './pipes/filter-pipe';


// For Custom Date Picker Formats
import { DATEPICKER_FORMATS, DATE_LOCALE_TOKEN } from './services/date-adapter/date-formats';
import { Platform } from '@angular/cdk/platform';
// UtilityService import removed (unused)
import { NavigationTabComponent } from './navigation-tab/navigation-tab.component';
import { AutoSyncComponent } from './dynamicform/components/auto-sync/auto-sync.component';
import { ContentComponent } from './dynamicform/components/content/content.component';
import { OfflineInfoComponent } from './offline-info/offline-info.component';
import { SupplierLocationsComponent } from './supplier-locations/supplier-locations.component';
import { BlockPasteDirective } from './directives/block-paste.directive';
import { NumberOnlyDirective } from './directives/num-only.directive';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { OfflineNoDataComponent } from './offline-no-data/offline-no-data.component';
import { NoMathComponent } from './no-math/no-math.component';
import { ItemDetailsHistoryComponent } from './item-details-history/item-details-history.component';
import { FormRadioComponent } from './dynamicform/components/form-radio/form-radio.component';
import { DigitOnlyDirective } from './directives/digit-only.directive';
import { NumDotOnlyDirective } from './directives/num-dot-only.directive';
import { LandingTableComponent } from './landing-table/landing-table.component';
import { PrevilegeAuthorizationModule } from '../authorization/authorization.module';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { DecimalFormatterPipe } from './pipes/decimal-formatter.pipe';
import { IdlePopupComponent } from './Idlepopup/idlepopup.component';
import { BarcodeMappingComponent } from './barcode-mapping/barcode-mapping.component';
import { LongPressDirective } from './directives/long-press.directive';
import { ImageTypePipe } from './pipes/file-type.pipe';
import { InnerHTMLPipe } from './pipes/inner-html.pipe';
import { DecimalConverterDirective } from './directives/decimal-converter.directive';
import { FocusOnConditionDirective } from './directives/focus-on-condition.directive';
import { LabelTextComponent } from './dynamicform/components/label-text/label-text.component';
import { DateFormater } from './pipes/date-formater.pipe';
import { BinManagementComponent } from './bin-management/bin-management.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentCustomDateAdapter } from './services/date-adapter/moment-custom-date-adapter.service';
import { AgilysysChangePasswordPopupComponent } from './popup/agilysys-change-password-popup/agilysys-change-password-popup.component';
import { CurrencyFormatterPipe } from './pipes/currency-formatter.pipe';
import { ConsignmentPopupComponent } from './consignment-popup/consignment-popup.component';
import { IosMinusButtonDirective } from './directives/ios-minus-button.directive';


@NgModule({
    exports: [
        TranslateModule,
        MatAutocompleteModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        ReactiveFormsModule,
        DynamicFieldDirective,
        DynamicFormComponent,
        FormButtonComponent,
        FormInputComponent,
        FormSelectComponent,
        FormTextareaComponent,
        FormNumberComponent,
        FormsModule,
        TileComponent,
        KeysValue,
        IsEmpty,
        SelectOptionPipe,
        ImageTypePipe,
        Sort,
        GetIconName,
        TrimLower,
        AutoCompleteComponent,
        RecentlySearchedComponent,
        InputtypeDirective,
        BottomPopOverComponent,
        TitleComponent,
        AutocompletesearchComponent,
        ToastMessageComponent,
        ItemListTableComponent,
        ItemDetailsComponent,
        ScrollingModule,
        RequiredLabelDirective,
        NummaxLengthDirective,
        ViewmoreDirective,
        SearchBoxComponent,
        TableSearchComponent,
        ServersideutoCompleteComponent,
        FormtoggleComponent,
        FormdateComponent,
        MatFormFieldModule,
        NgbModule,
        ScrollToTopComponent,
        SpinnerComponent,
        ListPackagesComponent,
        ResetbuttonComponent,
        FormInputAutocompleteComponent,
        FormAutocompleteComponent,
        HighlightPipe,
        FilterPipe,
        DecimalFormatterPipe,
        CurrencyFormatterPipe,
        NoItemsComponent,
        PackageListComponentComponent,
        NavigationTabComponent,
        AutoSyncComponent,
        ContentComponent,
        OfflineInfoComponent,
        SupplierLocationsComponent,
        CheckboxComponent,
        OfflineNoDataComponent,
        ItemDetailsHistoryComponent,
        FormRadioComponent,
        LandingTableComponent,
        AutoFocusDirective,
        BarcodeMappingComponent,
        LongPressDirective,
        InnerHTMLPipe,
        NumberOnlyDirective,
        DigitOnlyDirective,
        BlockPasteDirective,
        DecimalConverterDirective,
        LabelTextComponent,
        DateFormater,
        IosMinusButtonDirective,
        BinManagementComponent,
        ConsignmentPopupComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        MatAutocompleteModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        ScrollingModule,
        // PopoverModule,
        MatFormFieldModule,
        NgbModule,
        PrevilegeAuthorizationModule, DynamicFieldDirective,
        IosMinusButtonDirective,
        DynamicFormComponent,
        FormButtonComponent,
        FormInputComponent,
        FormSelectComponent,
        TileComponent,
        KeysValue,
        IsEmpty,
        SelectOptionPipe,
        ImageTypePipe,
        Sort,
        TrimLower,
        GetIconName,
        AutoCompleteComponent,
        RecentlySearchedComponent,
        InputtypeDirective,
        BottomPopOverComponent,
        TitleComponent,
        AutocompletesearchComponent,
        ToastMessageComponent,
        ItemListTableComponent,
        ItemDetailsComponent,
        RequiredLabelDirective,
        NummaxLengthDirective,
        SearchBoxComponent,
        PopupComponent,
        AgilysysChangePasswordPopupComponent,
        ConsignmentPopupComponent,
        IdlePopupComponent,
        TableSearchComponent,
        ServersideutoCompleteComponent,
        FormtoggleComponent,
        FormdateComponent,
        FormTextareaComponent,
        FormNumberComponent,
        ScrollToTopComponent,
        SpinnerComponent,
        ListPackagesComponent,
        AllLocationsComponent,
        ResetbuttonComponent,
        FormInputAutocompleteComponent,
        FormAutocompleteComponent,
        HighlightPipe,
        FilterPipe,
        DecimalFormatterPipe,
        CurrencyFormatterPipe,
        ViewmoreDirective,
        NoItemsComponent,
        PackageListComponentComponent,
        NavigationTabComponent,
        AutoSyncComponent,
        ContentComponent,
        OfflineInfoComponent,
        SupplierLocationsComponent,
        BlockPasteDirective,
        NumberOnlyDirective,
        CheckboxComponent,
        OfflineNoDataComponent,
        NoMathComponent,
        ItemDetailsHistoryComponent,
        FormRadioComponent,
        DigitOnlyDirective,
        NumDotOnlyDirective,
        LandingTableComponent,
        AutoFocusDirective,
        BarcodeMappingComponent,
        LongPressDirective,
        InnerHTMLPipe,
        DecimalConverterDirective,
        FocusOnConditionDirective,
        LabelTextComponent,
        DateFormater,
        BinManagementComponent],
    providers: [{
            // provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE, Platform, UtilityService ]
            provide: DateAdapter, useClass: MomentCustomDateAdapter, deps: [MAT_DATE_LOCALE, Platform, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: DATE_LOCALE_TOKEN, useValue: MAT_DATE_LOCALE
        },
        {
            provide: MAT_DATE_FORMATS, useValue: DATEPICKER_FORMATS
        }, DatePipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {

}
